// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".team[data-v-555d756e]{grid-column:1/3;grid-row:3/4;align-self:center;padding:2px;width:-moz-max-content;width:max-content;height:24px}.team__name[data-v-555d756e]{font-size:.75rem}.team__image[data-v-555d756e]{border-radius:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
